export const VUEX_NOTIFICATION_FETCH = 'VUEX_NOTIFICATION_FETCH'
export const VUEX_NOTIFICATIONS_FETCH = 'VUEX_NOTIFICATIONS_FETCH'
export const VUEX_NOTIFICATIONS_MARK_ALL_READ = 'VUEX_NOTIFICATIONS_MARK_ALL_READ'
export const VUEX_NOTIFICATIONS_UPDATE = 'VUEX_NOTIFICATIONS_UPDATE'
